import Vue from 'vue'

// eslint-disable-next-line
export const nameFormatter = (value) => {
  if (!value) return ''

  return value.toLowerCase().replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); });
}

Vue.filter('ToNameFormatted', nameFormatter)